import { getMonthlyInterestRate } from './getMonthlyInterestRate';

export function calculateMonthlyInterest(loanAmount: number): number {
  const rate = getMonthlyInterestRate();
  return loanAmount * rate;
}
